import { Calendar } from 'lucide-react';
import { daysAgo, today } from '../utils/format';

interface DateRangeFilterProps {
  start: string;
  end: string;
  onChange: (start: string, end: string) => void;
}

const PRESETS = [
  { label: '7D', days: 7 },
  { label: '30D', days: 30 },
  { label: '90D', days: 90 },
];

const DateRangeFilter: React.FC<DateRangeFilterProps> = ({ start, end, onChange }) => {
  const maxDate = today();

  const handleStart = (value: string) => {
    if (!value) return;
    onChange(value, value > end ? value : end);
  };

  const handleEnd = (value: string) => {
    if (!value) return;
    onChange(value < start ? value : start, value);
  };

  return (
    <div className="flex flex-wrap items-center gap-2 shrink-0">
      <div className="flex items-center rounded-lg bg-zinc-800/80 border border-zinc-700 p-0.5">
        {PRESETS.map((preset) => {
          const presetStart = daysAgo(preset.days - 1);
          const active = start === presetStart && end === maxDate;
          return (
            <button
              key={preset.label}
              type="button"
              onClick={() => onChange(presetStart, maxDate)}
              className={`px-2.5 py-1.5 text-xs font-medium rounded-md transition-colors ${
                active ? 'bg-zinc-700 text-white' : 'text-zinc-400 hover:text-white'
              }`}
            >
              {preset.label}
            </button>
          );
        })}
      </div>

      <div className="flex items-center gap-2 px-3 py-2 bg-zinc-800 border border-zinc-700 rounded-lg focus-within:border-zinc-600 transition-colors">
        <Calendar size={15} className="text-zinc-500 shrink-0" />
        <input
          type="date"
          value={start}
          max={end || maxDate}
          onChange={(e) => handleStart(e.target.value)}
          className="bg-transparent text-white text-sm focus:outline-none [color-scheme:dark]"
        />
        <span className="text-zinc-600">→</span>
        <input
          type="date"
          value={end}
          min={start}
          max={maxDate}
          onChange={(e) => handleEnd(e.target.value)}
          className="bg-transparent text-white text-sm focus:outline-none [color-scheme:dark]"
        />
      </div>
    </div>
  );
};

export default DateRangeFilter;
